// ============================================
// LIGA AJUPAM - "¿Quién sos?" → sesión del staff (v6.11.208)
// ============================================
// Opcional y silencioso: si el RPC todavía no existe (migración v6.11.208.00
// sin aplicar) o falla, el login sigue igual. Sólo se pierde la atribución.

import { supabase } from './client';

export const syncStaffDeviceLabel = async (sessionToken: string, label: string | null): Promise<void> => {
  if (!sessionToken) return;
  try {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    await (supabase.rpc as any)('staff_set_device_label', {
      p_session_token: sessionToken,
      p_label: label,
    });
  } catch { /* opcional */ }
};
